import {
    IconButton, Avatar, Box, CloseButton, Flex, HStack, VStack, Icon, useColorModeValue,
    Text, Drawer, DrawerContent, useDisclosure, Menu, MenuButton, MenuItem, Image,
    MenuList, AccordionButton, Accordion, AccordionPanel, AccordionItem, Tooltip, Spinner
} from "@chakra-ui/react"
import {
    FiSettings, FiMenu, FiEdit, FiChevronDown, FiBookOpen, FiUser, FiPackage, FiHelpCircle, FiRefreshCcw
} from "react-icons/fi"
import { FaBug, FaMoneyBillWave } from "react-icons/fa";
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import ColorModeToggle from "./ThemeButton"
import { useDispatch, useSelector } from "react-redux"
import { store } from "../redux/store"
import { partialReset } from "../redux/CreateDoc/createDocSlice"
import { useEffect, useState } from "react"
import { createPortal, getAccountById, handleSubscribe } from "../redux/Account/accountCalls";
import { getProducts } from "../redux/Product/productCalls";
import { getContacts } from "../redux/Contact/contactCalls";
import { getResources } from "../redux/Resource/resourceCalls";
import { getPaymentTerms } from "../redux/PaymentTerm/paymentTermCalls";
import { getArticles } from "../redux/Article/articleCalls";
import { getDocuments } from "../redux/Document/documentCalls";
import { getInviteUsers } from "../redux/InviteUser/inviteUserCalls";
import { getUsers } from "../redux/User/userCalls";
import rapidLogo from "../images/rapidToolzLogo.png"
import { useTranslation } from 'react-i18next'
import { signOut } from 'aws-amplify/auth';
import { toast } from "react-toastify";


const SidebarContent = ({ onClose, ...rest }) => { // text inside sidebar/drawer
    const { account_id } = useSelector((state) => state.account)
    const { account_email } = useSelector((state) => state.account)
    const { user_role } = useSelector((state) => state.auth)
    const { email } = useSelector((state) => state.auth)
    const { status } = useSelector((state) => state.account.subscription)
    const { history } = useSelector((state) => state.account.subscription)
    const { t } = useTranslation('common')
    const dispatch = useDispatch()
    var LinkItems = null

    if (user_role !== "user") {
        LinkItems = [
            // { name: t('create'), children: { [t('create_new_quote')]: "/create/quote", [t('create_quote_from_template')]: "/create/quote/template", [t('create_po')]: "/create/purchaseorder", [t('create_proforma')]: "/create/proforma" }, icon: FiEdit },
            { name: t('create'), children: { [t('create_new_quote')]: "/create/quote", [t('create_quote_from_template')]: "/create/quote/template", [t('create_po')]: "/create/purchaseorder", [t('create_template')]: "/create/template" }, icon: FiEdit },
            // { name: t('history'), children: { [t('quote_history')]: "/history/quote", [t('quote_history')]: "/history/quote", [t('po_history')]: "/history/purchaseorder", [t('invoice_history')]: "/history/invoice", [t('proforma_history')]: "/history/proforma", [t('draft_history')]: "/history/draft" }, icon: FiBookOpen },
            { name: t('history'), children: { [t('quote_history')]: "/history/quote", [t('template_history')]: "/history/template", [t('po_history')]: "/history/purchaseorder", [t('invoice_history')]: "/history/invoice", [t('draft_history')]: "/history/draft" }, icon: FiBookOpen },
            { name: t('account'), children: { [t('contacts')]: "/contacts", [t('products')]: "/products" }, icon: FiUser },
            { name: t('resources'), children: { [t('view_resources')]: "/resources" }, icon: FiPackage },
            { name: t('settings'), children: { [t('settings')]: "/settings" }, icon: FiSettings },
            { name: t('billing'), statusCheck: true, children: { [t('manage_billing')]: null }, icon: FaMoneyBillWave },
            { name: t('report_a_bug'), children: { [t('report_a_bug')]: "/reportbug" }, icon: FaBug },
            { name: t('help'), children: { [t('quick_start_guide')]: "/quick_start_guide" }, icon: FiHelpCircle }
            // { name: t('help'), children: { [t('help')]: "/help" }, icon: FiHelpCircle }
        ]
    } else {
        LinkItems = [
            // { name: t('create'), children: { [t('create_new_quote')]: "/create/quote", [t('create_quote_from_template')]: "/create/quote/template", [t('create_po')]: "/create/purchaseorder", [t('create_proforma')]: "/create/proforma" }, icon: FiEdit },
            { name: t('create'), children: { [t('create_new_quote')]: "/create/quote", [t('create_quote_from_template')]: "/create/quote/template", [t('create_po')]: "/create/purchaseorder" }, icon: FiEdit },
            // { name: t('history'), children: { [t('quote_history')]: "/history/quote", [t('quote_history')]: "/history/quote", [t('po_history')]: "/history/purchaseorder", [t('invoice_history')]: "/history/invoice", [t('proforma_history')]: "/history/proforma", [t('draft_history')]: "/history/draft" }, icon: FiBookOpen },
            { name: t('history'), children: { [t('quote_history')]: "/history/quote", [t('template_history')]: "/history/template", [t('po_history')]: "/history/purchaseorder", [t('invoice_history')]: "/history/invoice", [t('draft_history')]: "/history/draft" }, icon: FiBookOpen },
            { name: t('account'), children: { [t('contacts')]: "/contacts", [t('products')]: "/products" }, icon: FiUser },
            { name: t('resources'), children: { [t('view_resources')]: "/resources" }, icon: FiPackage },
            { name: t('settings'), children: { [t('settings')]: "/settings" }, icon: FiSettings },
            { name: t('billing'), statusCheck: true, children: { [t('manage_billing')]: null }, icon: FaMoneyBillWave },
            { name: t('report_a_bug'), children: { [t('report_a_bug')]: "/reportbug" }, icon: FaBug },
            { name: t('help'), children: { [t('quick_start_guide')]: "/quick_start_guide" }, icon: FiHelpCircle }
            // { name: t('help'), children: { [t('help')]: "/help" }, icon: FiHelpCircle }
        ]
    }

    // HR - get portal url and open in new tab
    async function handleManageBilling() {
        var url = await createPortal({ account_id, user_role })
        window.open(url, '_blank')
    }


    // HR - this function redirects user to stripe checkout page, autofilling user email and changes based on which plan they select
    function onSubscribeClick(frequency) {
        const targetEmail = (account_email === "" && user_role === "owner")
            ? email
            : account_email;

        const payload = {
            account_email: targetEmail,
            frequency: frequency // 'monthly' or 'yearly'
        };

        handleSubscribe(payload, dispatch);
    }

    return (
        <Box
            transition="3s ease"
            bg={useColorModeValue("white", "gray.900")}
            borderRight="1px"
            borderRightColor={useColorModeValue("gray.200", "gray.700")}
            w={"xs"}
            pos="fixed"
            h="full"
            overflow="auto"
            {...rest}
        >
            <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
                <NavLink to="/">
                    <Image src={rapidLogo} rounded={7.5} objectFit={'fill'} />
                </NavLink>
                <CloseButton display="flex" onClick={onClose} />
            </Flex>
            <Accordion allowMultiple >
                {LinkItems.map(link => (
                    <AccordionItem key={link.name}>
                        <AccordionButton>
                            <NavItem icon={link.icon}>
                                <Text fontFamily={""}>{link.name}</Text>
                            </NavItem>
                        </AccordionButton>
                        <AccordionPanel pb={4}>
                            {Object.entries(link.children).map(([title, route]) => {
                                if (!link.statusCheck) {
                                    return (
                                        <NavLink key={title} to={route}>
                                            <NavItem>
                                                {title}
                                            </NavItem>
                                        </NavLink>
                                    )
                                } else if (status === "active") {
                                    // HR - manage billing button, opens in new tab when clicked
                                    return (
                                        <NavItem onClick={handleManageBilling} key={title}>{t('manage_billing')}</NavItem>
                                    )
                                } else {
                                    return (
                                        <div key={title}>
                                            <NavItem onClick={() => onSubscribeClick("monthly")}>{t('new_sub_monthly')}</NavItem>
                                            <NavItem onClick={() => onSubscribeClick("yearly")}> {t('new_sub_yearly')}</NavItem>
                                        </div>
                                    )
                                }
                            })}
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    )
}

const NavItem = ({ icon, children, ...rest }) => { // each of the sidebar buttons
    return (
        <Box
            style={{ textDecoration: "none" }}
            _focus={{ boxShadow: "none" }}
        >
            <Flex
                align="center"
                p="3"
                mx="4"
                borderRadius="lg"
                role="group"
                cursor="pointer"
                _hover={{
                    color: "cyan.400"
                }}
                {...rest}
            >
                {icon && (
                    <Icon
                        mr="4"
                        fontSize="16"
                        _groupHover={{
                            color: "cyan.400"
                        }}
                        as={icon}
                    />
                )}
                {children}
            </Flex>
        </Box>
    )
}

const MobileNav = ({ onOpen, ...rest }) => {
    const { user_name } = useSelector((state) => state.auth)
    const { picture } = useSelector((state) => state.auth)
    const { account_id } = useSelector((state) => state.account)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const [spin, setSpin] = useState(false)
    const { t } = useTranslation('common')


    async function refreshData() {
        getAccountById(account_id, dispatch)
        getProducts(account_id, dispatch)
        getContacts(account_id, dispatch)
        getResources(account_id, dispatch)
        getPaymentTerms(account_id, dispatch)
        getDocuments(account_id, dispatch)
        getInviteUsers(account_id, dispatch)
        getUsers(account_id, dispatch)
        getArticles(dispatch)
    }

    async function handleSignOut() {
        try {
            await signOut();
            store.dispatch({ type: "RESET" })
            navigate('/')
            toast.success(t('successfully_logged_out'))
            // Redirect user to the login page here
        } catch (error) {
            toast.error(t('error_logging_out'))
            console.error(error);
        }
    }

    // HR - this function is for the spinning animation of the "Refresh Data" button
    const handleClick = async () => {
        setSpin(true);
        setTimeout(async () => {
            try {
                await refreshData();
            } catch (error) {
                console.error('Error refreshing data:', error);
            } finally {
                setSpin(false);
            }
        }, 500); // Add a 500ms (0.5 second) delay
    };

    useEffect(() => {
        // HR - used to reset createDoc state if user leaves create pages, works *okay* for now but still persists for a little when switching between create quote and po
        if (location.pathname !== '/edit/purchaseorder' && location.pathname !== '/edit/quote' && location.pathname !== '/edit/invoice' && location.pathname !== '/edit/template' && location.pathname !== '/edit/options'
            && location.pathname !== '/view/purchaseorder' && location.pathname !== '/view/quote' && location.pathname !== '/view/invoice' && location.pathname !== '/view/template') {
            if (location.pathname !== '/create/quote' || location.pathname !== '/create/purchaseorder' || location.pathname !== '/create/quote/template' || location.pathname !== '/create/template') {
                dispatch(partialReset())
            }
        }
    }, [location])


    return (
        <Flex
            ml={0}
            px={4}
            height="20"
            alignItems="center"
            bg={useColorModeValue("white", "gray.900")}
            borderBottomWidth="1px"
            borderBottomColor={useColorModeValue("gray.200", "gray.700")}
            justifyContent="space-between"
            {...rest}
        >
            {/* this is the hamburger icon */}
            <IconButton
                display="flex"
                onClick={onOpen}
                variant="outline"
                aria-label="open menu"
                icon={<FiMenu />}
            />
            <NavLink to="/" style={{ position: 'absolute', left: '50%', transform: 'translate(-50%, 0%)' }}>
                <Image src={rapidLogo} rounded={7.5} objectFit={'fill'} />
            </NavLink>
            <HStack spacing={[2, 4]}>
                <Tooltip label={t('refresh_data')} fontSize='sm'>
                    <IconButton
                        display="flex"
                        onClick={handleClick}
                        variant="solid"
                        aria-label={t('refresh_data')}
                        p={[2, 4]}
                        size={['xs', 'sm', 'md']}
                        icon={spin ? <Spinner size='sm' /> : <FiRefreshCcw />}
                    />
                </Tooltip>
                <ColorModeToggle size={['xs', 'sm', 'md']} />
                <Flex alignItems={"center"} ml={1}>
                    <Menu>
                        <MenuButton
                            py={2}
                            transition="all 0.3s"
                            _focus={{ boxShadow: "none" }}
                        >
                            <HStack>
                                <Avatar
                                    size={"sm"}
                                    src={picture}
                                    content="no-referrer"
                                />
                                <VStack
                                    display={{ base: "none", md: "flex" }}
                                    alignItems="flex-start"
                                    spacing="1px"
                                    ml="2"
                                >
                                    <Text fontSize="sm">{user_name}</Text>
                                </VStack>
                                <Box display={{ base: "none", md: "flex" }}>
                                    <FiChevronDown />
                                </Box>
                            </HStack>
                        </MenuButton>
                        <MenuList>
                            <MenuItem as="button" onClick={handleSignOut}>{t('logout')}</MenuItem>
                        </MenuList>
                    </Menu>
                </Flex>
            </HStack>
        </Flex>
    )
}

const SidebarWithHeader = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    return (
        <Box>
            <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                returnFocusOnClose={false}
                size={'xs'}
            >
                <DrawerContent>
                    <SidebarContent onClose={onClose} />
                </DrawerContent>
            </Drawer>
            <MobileNav onOpen={onOpen} />
        </Box>
    )
}

export default SidebarWithHeader
